import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { RefuseBatchParticipationPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const refuseBatchPayment = createAsyncThunk<void, RefuseBatchParticipationPaymentBody, { extra: Partial<Dependencies> }>(
  "batchPayments/refuseBatchPayment",
  async (data: RefuseBatchParticipationPaymentBody, { extra: { adminRepository } }) => {
    return adminRepository!.refusePayment(data);
  },
);

export const resetRefuseBatchPayment = createAction("batchPayments/resetRefuseBatchPayment");
